<template lang="pug">
  .table-responsive
    table#tbResumenes.table.is-striped.is-fullwidth.is-narrow(v-show="hayDatos")
      thead
        tr
          th.is-size-6
            | #
          th.is-size-6 
            | Periodo
          th.is-size-6 
            | Usuario
          th.is-size-6 
            | Reviso
          th.is-size-6 
            | Autorizó
          th.is-size-6 
            | Ubicación
          th.is-size-6 
            | Importe Total
          th.is-size-6 
            | Km Total
          th.is-size-6 
            | Promedio
          th.is-size-6 
            | Calidad
      tbody
        tr(v-for="(resum, index) in resumenes" :key="resum.id")
          td
            a.button.is-black.is-rounded.is-small {{ index + 1 }}&nbsp
            a.button.is-text.is-rounded.is-small(@click="printResumen(resum)")
              i.fas.fa-print
          td
            | {{ resum.periodo }}
          td
            a.button.is-text.is-small(@click="firmar('u', resum)")
              | {{ resum.nombre_usuario }}
            a.button.is-rounded.is-small(v-show="isSigned(resum.firma_realizo)")
              i.fas.fa-signature
          td
            a.button.is-text.is-small(@click="firmar('r', resum)")
              | {{ resum.reviso }}
            a.button.is-rounded.is-small(v-show="isSigned(resum.firma_reviso)")
              i.fas.fa-signature
          td
            a.button.is-text.is-small(@click="firmar('a', resum)")
              | {{ resum.autorizo }}
            a.button.is-rounded.is-small(v-show="isSigned(resum.firma_autorizo)")
              i.fas.fa-signature
          td
            | {{ resum.ubicacion === 'LPG_DUCTO' ? 'DUCTO' : resum.ubicacion }}
          td
            | {{ resum.importeTotal | currency }}
          td
            | {{ resum.km_total }}
          td
            | {{ resum.promedio }}
          td
            | {{ resum.calidad }}
    .notification(v-show="!hayDatos")
      strong  No registros para esta búsqueda.
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Tb_Resumenes',
    props: {
      resumenes: {
        type: Array,
        default: []
      },
      resumenSel: {
        type: Object,
        default () {
          return {
            vacio: true
          }
        }
      }
    },
    data() {
      return {
        hayDatos: true,
        itemsSelected: {},
        isDisabled: true
      }
    },
    watch: {
      resumenes() {
        this.checkDatos()  
      },
      disabledItems() {
        this.isDisabled = this.disabledItems
      },
      itemsSelected () {
        this.$emit('seleccionarItem', this.itemsSelected)
      },
      reset () {
        console.log(`Reset: ${this.reset}`)
        if (this.reset) {
          this.itemsSelected = {}
        }
      },
      resumenSel () {
        this.itemsSelected = Object.assign({}, this.itemsSelected, this.resumenSel)
      },
    },
    methods: {
      iniciarComponente () {
        console.log(this.resumenSel)
        // this.checkDatos()
      },
      checkDatos () {
        if (this.resumenes.length > 0) {
          this.hayDatos = true
        } else {
          this.hayDatos = false
        }
      },
      firmar(user, data) {
        switch (user) {
          case 'u':
            if (this.userLogin.id === data.id_usuario) {
              console.log('Pasa a firma del Usuario')
              this.firmarReporte(data)
            } else {
              console.log('No es el usuario que la creo')
            }
            break
          case 'r':
            if (this.userLogin.id === data.id_reviso) {
              this.firmarReporte(data)
            } else {
              console.log('No es el usuario que la creo')
            }
            break
          case 'a':
            if (this.userLogin.id === data.id_autorizo) {
              this.firmarReporte(data)
            } else {
              console.log('No es el usuario que la creo')
            }
            break
        
          default:
            break
        }
      },
      isSigned(val) {
        let verFirma = false

        if (val === '') {
          verFirma = false
        } else {
          verFirma = true
        }
        return verFirma
      },
      firmarReporte(reporte) {
        this.isLoading = false
        this.$store.commit('firmarReporte', reporte)
        this.$router.push('/Transportes/Combustible/Resumen/Firma')
      },
      printResumen(resumen) {
        var currentUrl = window.location.hostname
        console.log(currentUrl)
        let link = `https://${currentUrl}/servidores/reportes/inventarios/combustibleI.php?id=${resumen.id}`
        window.open(link, '_blank')
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/Tb_Resumenes.vue